var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"one_01"},[_c('router-tab',{attrs:{"append":"last","keep-last-tab":false,"restore":"false","icon":"el-icon-menu"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }